import {Route} from 'react-router-dom';
import navConstants from '../constants/navConstants';
import {Login, Callback, Logout, Unavailable} from '../components/pages/auth';
import DeepLinkingScreen from '../components/pages/auth/DeepLinkingScreen';

export const useAuthRoutes = () => {
  return (
    <>
      <Route path={navConstants.auth.login} element={<Login />} />
      <Route path={navConstants.auth.callback} element={<Callback />} />
      <Route
        path={navConstants.auth.deepLink}
        element={<DeepLinkingScreen />}
      />
      <Route path={navConstants.auth.logout} element={<Logout />} />
      <Route path={navConstants.auth.unavailable} element={<Unavailable />} />
    </>
  );
};
